import { useMemo } from "react";
import { 
  getShapeStyles
} from "../utils/cropUtils";

/**
 * Custom hook for image styling calculations.
 * 
 * Since we use server-side cropping, this now handles only shapes, rotation, and sizing.
 * The actual cropping is done server-side and served via cropped_image_url.
 */
const useCropCalculations = (imageItem = null) => {
  const calculations = useMemo(() => {
    // Default values
    const defaultResult = {
      // CSS properties (no crop styles needed - server-side cropping)
      imageStyles: {},
      containerStyles: {},
      
      // State flags
      hasCrop: false,
      isInteractive: false,
      hasShape: false,
      hasRotation: false,
      hasCustomSize: false,
      hasModernSizing: false
    };

    // No image item provided
    if (!imageItem) {
      return defaultResult;
    }

    const { 
      crop_viewport, 
      format = "original", 
      rotation = 0
    } = imageItem;
    
    // Check feature flags
    const isInteractive = !!crop_viewport;
    const hasCrop = isInteractive && (
      crop_viewport.crop_left !== 0 || 
      crop_viewport.crop_top !== 0 || 
      crop_viewport.crop_width !== 100 || 
      crop_viewport.crop_height !== 100
    );
    const hasShape = format && format !== "original";
    const hasRotation = rotation && Math.abs(rotation) > 0.1;
    
    // Generate styling (no crop styles - server handles cropping)
    let imageStyles = {};
    let containerStyles = {};
    
    // Add shape styles
    if (hasShape) {
      imageStyles = { ...imageStyles, ...getShapeStyles(format) };
    }
    
    // Add rotation
    if (hasRotation) {
      imageStyles.transform = `rotate(${rotation}deg)`;
    }
    
    
    return {
      imageStyles,
      containerStyles,
      hasCrop,
      isInteractive,
      hasShape,
      hasRotation
    };
  }, [
    imageItem?.crop_viewport?.crop_left,
    imageItem?.crop_viewport?.crop_top,
    imageItem?.crop_viewport?.crop_width,
    imageItem?.crop_viewport?.crop_height,
    imageItem?.format,
    imageItem?.rotation
  ]);

  return calculations;
};

export default useCropCalculations;
